import axios from 'axios';

/**
 * HTTP Get service. Used for all the GET rest calls.
 */

 class HttpService {
    constructor() {}

    public get = (url: string): Promise<any> => {
        return new Promise((resolve, reject) => {
            axios.get(url, {
            }).then(response => {
                resolve(response.data)
            }).catch(error => {
                if (error.response && error.response.status === 404) {
                    resolve(null)
                } else if (error.response && error.response.status === 401) {
                    //page refresh to force login
                    location.reload();
                } else {
                    reject(error);
                }
            });
        });
    }

    public getItemReject204 = (url: string): Promise<any> => {
        return new Promise((resolve, reject) => {
            axios.get(url, {
                withCredentials: (process.env.NODE_ENV !== "development")
            }).then(response => {
                if (response.status === 204){
                    reject(204)
                }
                else {
                    resolve(response.data)
                }
            }).catch(error => {
                reject(error);
            });
        });
    }

    public getItem = (url: string): Promise<any> => {
        return new Promise((resolve, reject) => {
            axios.get(url, {
                withCredentials: true
            }).then(response => {
                resolve(response.data)
            }).catch(error => {
                if (error.response && error.response.status === 404) {
                    resolve(null)
                } else {
                    reject(error);
                }
            });
        });
    }

    public getList = (url: string): Promise<any> => {
        return new Promise((resolve, reject) => {
            axios.get(url, {
                withCredentials: true
            }).then(response => {
                resolve(response.data);
            }).catch(error => {
                if (error.response && error.response.status === 404) {
                    resolve([]);
                } else {
                    reject(error);
                }
            });
        });
    }

    public post = (url: string, data: any, headers?: any): Promise<any> => {
        return new Promise((resolve, reject) => {
            axios.post(url, data, {
                headers: headers
            }).then(response => {
                resolve(response.data)
            }).catch(error => {
                if (error.response && error.response.status === 404) {
                    resolve(null)
                } else {
                    reject(error);
                }
            });
        });
    }

    ///POST FROM PERSONAL VUE PROJECT
    public postRefresh = (url: string, data: any): Promise<any> => {
        return new Promise((resolve, reject) => {
            axios.post(url, data).then(response => {
                resolve(response.data)
            }).catch(error => {
                if (error.response && error.response.status === 404) {
                    resolve(null)
                } else if (error.response && error.response.status === 401) {
                    //page refresh to force login
                    location.reload();
                } else {
                    reject(error);
                }
            });
        });
    }

    public delete = (url: string, data: any): Promise<any> => {
        return new Promise((resolve, reject) => {
            axios.delete(url, data).then(response => {
                resolve(response.data)
            }).catch(error => {
                if (error.response && error.response.status === 404) {
                    resolve(null)
                } else {
                    reject(error);
                }
            });
        });
    }
}

export default new HttpService();
